import { all, call, put, takeLatest } from 'redux-saga/effects';

import {
  APP_REQUEST_INITIAL_DATA,
  APP_RECEIVE_INITIAL_DATA,
} from '../constants';
import {
  JOB_API_NAME as OPPORTUNITY_API_NAME,
  NOTIFICATIONS,
  TALENT_API_NAME,
} from '../../api/constants';
import { getNotifications } from '../../api/notifications-api';
import { opportunitiesError } from '../actions/opportunities';
import {
  getNotificationsSuccess,
  getNotificationsError,
} from '../actions/notifications';
import { talentError } from '../actions/talent';
import { addApiError } from '../actions/app';
import { PreloadedBarredLocationsStore } from '../../stores/preloaded-barred-locations-store';
import { PreloadedFeatureFlagsStore } from '../../stores/preloaded-feature-flags-store';
import { PreloadedGroupsStore } from '../../stores/preloaded-groups-store';
import { PreloadedLanguagesStore } from '../../stores/preloaded-languages-store';
import { PreloadedUsersStore } from '../../stores/preloaded-users-store';

const errorActions = {
  [OPPORTUNITY_API_NAME]: opportunitiesError,
  [NOTIFICATIONS]: getNotificationsError,
  [TALENT_API_NAME]: talentError,
};

export function* initialAppDataSagaGenerator(props) {
  const {
    payload: { id, firstName, lastName, email, roles },
  } = props;

  try {
    const [notifications] = yield all([
      call(getNotifications, {
        userId: id,
        page: 1,
      }),
    ]);
    yield put(getNotificationsSuccess({ notifications, userId: id }));

    PreloadedFeatureFlagsStore.bootstrap({
      id,
      firstName,
      lastName,
      email,
      roles,
    });

    Promise.all([
      PreloadedBarredLocationsStore.load(),
      PreloadedFeatureFlagsStore.load(),
      PreloadedGroupsStore.load(),
      PreloadedLanguagesStore.load(),
      PreloadedUsersStore.load(),
    ]);

    yield put({ type: APP_RECEIVE_INITIAL_DATA });
  } catch (e) {
    const appErr = e && e.applicationError ? e.applicationError : e;
    yield put(addApiError(appErr));
    if (appErr && appErr.apiName && errorActions[appErr.apiName]) {
      yield put(errorActions[appErr.apiName](e));
    }
  }
}

function* formsSaga() {
  yield takeLatest(APP_REQUEST_INITIAL_DATA, initialAppDataSagaGenerator);
}

export default formsSaga;
